import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST_FAILURE:
    case types.GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST_FAILURE:
      return {
        title: t('message.title.error.get.equipment.list'),
        message: t(getErrorMessage(data)),
        type: 'error',
      };
    default:
      return false;
  }
};
